import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import environment from '../../environments/environment';
import { resetParticipantAdminProfile } from '../../store/features/auth/participantAdminProfileSlice';
import { RootState } from '../../store/store';
import { saveAuditlog } from '../fiscalUpgrade/services/AuditLogs/AuditLogsServices';
import { getCurrentPSTTime } from '../fiscalUpgrade/Utils/dayjsWithTZ';
import PopUp from "../PopUp/PopUp";

const SessionTimeoutHandler: React.FC = () => {
    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const translate = t as (key: string) => string;
    const userDetails = useSelector((state: RootState) => state.auth);

    const handlePopUpClose = () => {
        setOpenPopUp(false);
    };

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            sessionStorage.setItem("sessionExpired", "true");
            setOpenPopUp(true);
        }, environment.session_timeout_duration);
    };

    useEffect(() => {
        if (sessionStorage.getItem("sessionExpired") === "true") {
            setOpenPopUp(true);
        }
        const activityEvents = ['mousemove', 'keydown', 'scroll', 'click'];
        const handleActivity = () => {
            resetTimer();
        };
        activityEvents.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );
        resetTimer();
        return () => {
            activityEvents.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    const handleConfirm = () => {
        sessionStorage.removeItem("sessionExpired");
        if (userDetails?.isLogin) {
            const auditLogs = {
                auditLogId: 0,
                dateChanged: getCurrentPSTTime(),
                clientId: userDetails.clientId,
                participantId: userDetails.defaultParticipantId,
                user: `${userDetails.firstName} ${userDetails.lastName}`,
                event: "Logout",
                description: `${userDetails.firstName} has Logout.`,
                amount: 0.0,
                version: 0
            };
            dispatch(resetParticipantAdminProfile());
            saveAuditlog(auditLogs).finally(() => {
                window.location.href = `https://login.microsoftonline.com/${environment.tenant}/oauth2/logout?post_logout_redirect_uri=${environment.ApplicationURL}`;
            });
        }
    };

    return (
        <>
            <PopUp
                open={openPopUp}
                popupTitle={translate('sessionTimeOut')}
                handleClose={handlePopUpClose}
                saveChanges={handleConfirm}
                message={translate('yourSessionHasExpiredDueToInactivityForSecurityReasonsPleaseLogInAgainToContinue')}
            />
        </>
    );
};

export default SessionTimeoutHandler;